<template>
  <VaSidebar class="min-h-full w-full sidebar" :color="isDark ? 'red-800' : 'primary'" :width="breakpoints.greaterOrEqual('xl').value ? '250px' : '200px'">
    <div class="min-h-[80px] w-full flex flex-row justify-center pt-1 pb-6">
      <RouterLink :to="{ name: 'home' }">
        <img class="h-14" src="@/assets/images/logo.png" alt="Logo" />
      </RouterLink>
    </div>

    <template v-for="item in currentMenuItems" :key="item.route">
      <VaSpacer v-if="item.spacer" />
      <RouterLink
        :to="item.route"
        class="sidebar-item"
        :class="{ 'router-active': routeMatch(item) }"
      >
        <VaSidebarItem :active="routeMatch(item)" active-color="red-600" class="group/item">
          <VaSidebarItemContent class="py-6 pl-9">
            <VaIcon size="22px" :name="item.icon" />
            <VaSidebarItemTitle class="text-lg">
              {{ t(item.textKey) }}
            </VaSidebarItemTitle>
          </VaSidebarItemContent>
        </VaSidebarItem>
      </RouterLink>
    </template>
  </VaSidebar>
</template>

<script lang="ts" setup>
import { VaIcon, VaSidebar, VaSidebarItem, VaSidebarItemContent, VaSidebarItemTitle, VaSpacer } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/UserStore'
import { computed } from 'vue'
import {
  RouteLocationAsRelativeGeneric,
  useRoute
} from 'vue-router'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import Config from '@/utils/config'

const breakpoints = useBreakpoints(breakpointsTailwind)
const route = useRoute()
const userStore = useUserStore()
const { t } = useI18n()

interface MenuItem {
  disabled?: boolean
  icon?: string
  route: RouteLocationAsRelativeGeneric
  spacer?: boolean
  textKey: string
}

const currentMenuItems = computed((): MenuItem[] => {
  let items: MenuItem[] = []
  if (userStore.isLoggedIn) {
    if (userStore.user?.roles?.includes('admin')) {
      items = menuItemsAdmin.value
    }
  }
  return items.filter(item => !item.disabled)
})

const isDark = computed(() => {
  if (Config.ssr) return false
  return document.documentElement.classList.contains('dark')
})

const menuItemsAdmin = computed((): MenuItem[] => [
  { textKey: 'menu.dashboard', icon: 'home', route: { name: 'home' } },
  { textKey: 'menu.users', icon: 'person', route: { name: 'admin.users' } },
  { textKey: 'menu.sponsors', icon: 'handshake', route: { name: 'admin.sponsors' } },
  { textKey: 'menu.mails', icon: 'mail', route: { name: 'admin.mails' } },
  { textKey: 'menu.surveys', icon: 'poll', route: { name: 'admin.surveys' } },
  { textKey: 'menu.reports', icon: 'print', route: { name: 'admin.reports' } },
  { textKey: 'menu.userGroups', icon: 'group', route: { name: 'admin.user-groups' }, spacer: true },
  { textKey: 'menu.templates', icon: 'description', route: { name: 'admin.templates' } },
])

const routeMatch = (item: MenuItem) => {
  return route.name === item.route?.name
}
</script>
